const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILE_STATUS';

export { UPDATE_PROFILE_STATUS };
